module.exports = __webpack_public_path__ + "static/img/bg-home-car.4df323ce.jpg";